"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryEvidenceRows = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const value_comparison_1 = require("../Comparison/value-comparison");
const boundary_conditions_comparison_1 = require("../Consensus/comparisons/boundary-conditions.comparison");
const signal_attributes_comparison_1 = require("../Consensus/comparisons/signal-attributes.comparison");
const general_package_slices_1 = require("../Consensus/general-slices/general-package-slices");
const slice_key_1 = require("../Consensus/slice-key");
const slice_version_1 = require("../Consensus/slice-version");
class BoundaryEvidenceRows {
    static { this.BOUNDARY_COMPARISON = new boundary_conditions_comparison_1.BoundaryConditionsComparison(); }
    static { this.SIGNAL_ATTRIBUTES_COMPARISON = new signal_attributes_comparison_1.SignalAttributesComparison(); }
    static { this.SLICES = [
        { kind: general_package_slices_1.BoundaryConditionKind.Amr, sliceKey: slice_key_1.SliceKey.AmrBoundaries },
        { kind: general_package_slices_1.BoundaryConditionKind.Oc, sliceKey: slice_key_1.SliceKey.OcBoundaries },
    ]; }
    static of(boundary, context, logger = (0, sigma_engine_shared_1.generateCompatibleConsoleLogger)()) {
        return BoundaryEvidenceRows.SLICES.flatMap(({ kind, sliceKey }) => (0, general_package_slices_1.buildBoundaryConditionRows)({ boundaries: [boundary], signals: context.signals, modes: context.modes }, kind, logger).map((row) => ({
            sliceKey,
            sliceVersion: (0, slice_version_1.sliceVersionFor)(sliceKey),
            rowKey: BoundaryEvidenceRows.BOUNDARY_COMPARISON.rowKeyOf(row),
            signalName: row.signalName,
            minimum: row.minimum,
            nominal: row.nominal,
            maximum: row.maximum,
        })));
    }
    static signalAttributesRowKey(signalName) {
        const comparison = BoundaryEvidenceRows.SIGNAL_ATTRIBUTES_COMPARISON;
        return (0, value_comparison_1.compositeKey)({ signalName }, comparison.alignment.keyColumns.map(String), (column, value) => comparison.normalize(column, value));
    }
}
exports.BoundaryEvidenceRows = BoundaryEvidenceRows;
//# sourceMappingURL=boundary-evidence-rows.js.map